import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-modal',
  imports: [],
  templateUrl: './modal.component.html',
  standalone: true,
  styleUrl: './modal.component.scss'
})
export class ModalComponent {

  @Output() close = new EventEmitter<void>();

  closeModal(): void {
    this.close.emit();
  }

  @Input()
  isOpen = false;
  //
  // private cdRef = inject(ChangeDetectorRef);
  //
  // openModal() {
  //   this.isOpen = true;
  //   this.cdRef.detectChanges();
  // }
  //
  // closeModal() {
  //   this.isOpen = false;
  //   this.cdRef.detectChanges();
  // }
  //
  // ngOnChanges() {
  //   if (this.isOpen) {
  //     this.openModal();
  //   } else {
  //     this.closeModal();
  //   }
  // }
}
